import get from 'lodash/get';
import { RootState } from '../../stores/types';
import AuthState from './types/state';

export const getAuthDocs = (state: RootState): AuthState['docs'] => get(state, 'auth.docs');
export const getAuthRedirectLocation = (state: RootState): AuthState['redirect']['location'] => get(state, 'auth.redirect.location');
export const getAuthRedirectStatus = (state: RootState): AuthState['redirect']['status'] => get(state, 'auth.redirect.status');

export default {}; // no defualt export from this module
